<template>
  <svg class="col" :style="{'height': svgHeight+'px', 'width': svgWidth+'px'}" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <marker id="arrow" markerWidth="13" markerHeight="13" refx="2" refy="6" orient="auto">
        <path d="M0,0 L0,9 L8,5 L0,1" style="fill:red;" />
      </marker>
    </defs>

    <circle v-for="(displayedCpaPoint,i) in displayedCpaPoints.filter(x => displayCpaPoints)" :key="'svg-cpa-point-'+i" @mouseover="onMouseOverCpaPoint(displayedCpaPoint)" @mouseleave="onMouseLeaveCpaPoint()" :cx="displayedCpaPoint.x" :cy="displayedCpaPoint.y" r="4" stroke="black" stroke-width="2" fill="#ff6600"/>
    <text v-for="(displayedCpaPoint,i) in displayedCpaPoints.filter(x => displayCpaPoints)" :key="'svg-cpa-text-'+i" @mouseover="onMouseOverCpaPoint(displayedCpaPoint)" @mouseleave="onMouseLeaveCpaPoint()" :x="displayedCpaPoint.x+10" :y="svgHeight - 9" fill="#ff6600" font-size="1rem">{{ i }}</text>
<!--
    <path v-for="(displayedCpaLink, i) in displayedCpaLinks" :key="'svg-cpa-link-'+i" :d="displayedCpaLink.svgLink"
              :stroke="(isHoverLink(displayedCpaLink)) ? '#ff6600' : 'darkgrey'"
              :stroke-width="(isHoverLink(displayedCpaLink)) ? '1.75' : '1'"
              fill="none"
              :style="(isHoverLink(displayedCpaLink)) ? {} : {'opacity': '0.5'}"/>
-->
    <path v-for="(displayedCpaLink, i) in displayedCpaLinks" :key="'svg-cpa-link-start-'+i" :d="displayedCpaLink.svgLinkStart"
              :stroke="(isHoverLink(displayedCpaLink)) ? '#ff6600' : 'darkgrey'"
              :stroke-width="(isHoverLink(displayedCpaLink)) ? '1.75' : '1'"
              fill="none"
              :style="(isHoverLink(displayedCpaLink)) ? {} : {'opacity': '0.5'}"/>
    <path v-for="(displayedCpaLink, i) in displayedCpaLinks" :key="'svg-cpa-link-end-'+i" :d="displayedCpaLink.svgLinkEnd"
              :stroke="(isHoverLink(displayedCpaLink)) ? '#ff6600' : 'darkgrey'"
              :stroke-width="(isHoverLink(displayedCpaLink)) ? '1.75' : '1'"
              fill="none"
              :style="(isHoverLink(displayedCpaLink)) ? {} : {'opacity': '0.5'}"/>
    <circle v-for="(displayedCpaLink,i) in displayedCpaLinks" :key="'svg-cpa-point-middle'+i" @mouseover="onMouseOverHeader(displayedCpaLink.cpa.cpaHead, displayedCpaLink.cpa.cpaTail)" @mouseleave="onMouseLeaveHeader()"
              :cx="displayedCpaLink.svgLinkMiddlePointX"
              :cy="displayedCpaLink.svgLinkMiddlePointY" r="5"
              :stroke="(isHoverLink(displayedCpaLink)) ? '#ff6600' : 'darkgrey'"
              :style="(isHoverLink(displayedCpaLink)) ? {'z-index': '100'} : {'z-index': '100', 'opacity': '0.65'}"
              class="clickable"
              @click="selectCpa((displayedCpaLink !== undefined) ? displayedCpaLink.cpa : undefined)"
              stroke-width="2" fill="white"/>
    <path v-for="(displayedCpaLink,i) in displayedCpaLinks.filter(displayedCpaLink => (displayedCpaLink.cpa.cpaHead < displayedCpaLink.cpa.cpaTail))" :key="'svg-cpa-upper-middle'+i" @mouseover="onMouseOverHeader(displayedCpaLink.cpa.cpaHead, displayedCpaLink.cpa.cpaTail)" @mouseleave="onMouseLeaveHeader()"
              :d="displayedCpaLink.svgLinkUpperMiddle"
              :stroke="(isHoverLink(displayedCpaLink)) ? '#ff6600' : 'darkgrey'"
              :style="(isHoverLink(displayedCpaLink)) ? {} : {'opacity': '0.65'}"
              class="clickable"
              @click="selectCpa((displayedCpaLink !== undefined) ? displayedCpaLink.cpa : undefined)"
              stroke-width="2" fill="none"/>
    <path v-for="(displayedCpaLink,i) in displayedCpaLinks.filter(displayedCpaLink => (displayedCpaLink.cpa.cpaHead > displayedCpaLink.cpa.cpaTail))" :key="'svg-cpa-lower-middle'+i" @mouseover="onMouseOverHeader(displayedCpaLink.cpa.cpaHead, displayedCpaLink.cpa.cpaTail)" @mouseleave="onMouseLeaveHeader()"
              :d="displayedCpaLink.svgLinkLowerMiddle"
              :stroke="(isHoverLink(displayedCpaLink)) ? '#ff6600' : 'darkgrey'"
              :style="(isHoverLink(displayedCpaLink)) ? {} : {'opacity': '0.65'}"
              class="clickable"
              @click="selectCpa((displayedCpaLink !== undefined) ? displayedCpaLink.cpa : undefined)"
              stroke-width="2" fill="none"/>

  </svg>
</template>
<script>
const ARE_SVG_LINKS_SORTED_BY_INDEX_DIFF = true;

export default {
  name: "SvgCPADisplayer",
  components: {
  },
  props: [
    "svgWidth",
    "cpaLineRefsBounds",
    "svgLeftBorder",
//    "cpaTableMatrixToMerge",
    "filteredCpaElementsToMerge",
    "hoverCoordinates",
    "svgHoverPoint",
    "isCpaMerged"
  ],
  data() {
    return {
      // initialLinkOffset: 20,
      initialLinkOffset: 8,
      displayCpaPoints: false,
      // svgHoverPoint: undefined,
      offsetGap: 2,
      offsetsUsed: [],
      displayedOffsetsUsed: [],
      lastCalculatedSvgHeight: 0,
    }
  },
  mounted() {
  },
  updated() {
  },
  computed: {
    displayedCpaPoints: function() {
      return this.cpaLineRefsBounds.map((displayedCpaLineRefBounds, displayedCpaLineRefBoundsIndex) => {
        const isDisplayed = ((displayedCpaLineRefBounds.width !== 0) || (displayedCpaLineRefBounds.height !== 0));
        return { x: (displayedCpaLineRefBounds.x - 3 - 9.8 + (displayedCpaLineRefBounds.width / 2) - this.svgLeftBorder), y: this.svgHeight - 15, columnIndex: displayedCpaLineRefBoundsIndex, isDisplayed: isDisplayed};
      })
    },
    displayedCpaLinks: function() {
      const displayedSvgCpaPoints = this.displayedCpaPoints;
      const displayedSvgHeight = this.svgHeight;
      if ((displayedSvgCpaPoints !== undefined) && (displayedSvgCpaPoints.length > 0)) {
        const tempDisplayedCpaLinks = [];
        this.initTopOffset(10);

        if (ARE_SVG_LINKS_SORTED_BY_INDEX_DIFF) {
          // NEAR COLUMNS FIRST DURING SVG LINK TOP OFFSET DEFINITION
          if (this.isCpaMerged) {
            const mergedCpaArrayToDisplay = this.getSortedFilteredAndMergedCpaArrayToDisplay();

            mergedCpaArrayToDisplay.forEach((mergedCpaToDisplay) => {

              const tempDisplayedCpaLinksObject = { fromPoint: displayedSvgCpaPoints[mergedCpaToDisplay.cpaColumn], toPoint: displayedSvgCpaPoints[mergedCpaToDisplay.cpaLinkedColumn], diff: (mergedCpaToDisplay.cpaLinkedColumn - mergedCpaToDisplay.cpaColumn), cpa: mergedCpaToDisplay};
              const topOffset = this.defineTopOffset(mergedCpaToDisplay.cpaColumn, mergedCpaToDisplay.cpaLinkedColumn);
              const linkLineSize = tempDisplayedCpaLinksObject.toPoint.x - tempDisplayedCpaLinksObject.fromPoint.x - (2 * topOffset);
              const halfLinkLineSize = linkLineSize>0 ? linkLineSize/2 : -linkLineSize/2;
              tempDisplayedCpaLinksObject.svgLink = `M${tempDisplayedCpaLinksObject.fromPoint.x},${displayedSvgHeight - 20} a${topOffset} ${topOffset} 0 0 1 ${topOffset} -${topOffset} h ${ linkLineSize>0 ? linkLineSize : -linkLineSize } a${topOffset} ${topOffset} 0 0 1 ${topOffset} ${topOffset}`;
              if (this.displayCpaPoints) {
                tempDisplayedCpaLinksObject.svgLinkStart = `M${tempDisplayedCpaLinksObject.fromPoint.x},${displayedSvgHeight - this.initialLinkOffset} a${topOffset} ${topOffset} 0 0 1 ${topOffset} -${topOffset} h ${ halfLinkLineSize - 4}`;
                tempDisplayedCpaLinksObject.svgLinkEnd = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset + 4},${displayedSvgHeight - this.initialLinkOffset - topOffset} h ${ halfLinkLineSize - 4 } a${topOffset} ${topOffset} 0 0 1 ${topOffset} ${topOffset}`;
                tempDisplayedCpaLinksObject.svgLinkMiddlePointX = tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset;
                tempDisplayedCpaLinksObject.svgLinkMiddlePointY = displayedSvgHeight - this.initialLinkOffset - topOffset;
                tempDisplayedCpaLinksObject.svgLinkUpperMiddle = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset -1.5 },${displayedSvgHeight - this.initialLinkOffset - topOffset - 3} l ${ 3 } ${ 3 } l ${ -3 } ${ 3 }`;
                tempDisplayedCpaLinksObject.svgLinkLowerMiddle = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset +1.5 },${displayedSvgHeight - this.initialLinkOffset - topOffset - 3} l ${ -3 } ${ 3 } l ${ 3 } ${ 3 }`;
              } else {
                tempDisplayedCpaLinksObject.svgLinkStart = `M${tempDisplayedCpaLinksObject.fromPoint.x},${displayedSvgHeight} v${-this.initialLinkOffset} a${topOffset} ${topOffset} 0 0 1 ${topOffset} -${topOffset} h ${ halfLinkLineSize - 4}`;
                tempDisplayedCpaLinksObject.svgLinkEnd = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset + 4},${displayedSvgHeight - this.initialLinkOffset - topOffset} h ${ halfLinkLineSize - 4 } a${topOffset} ${topOffset} 0 0 1 ${topOffset} ${topOffset} v${this.initialLinkOffset}`;
                tempDisplayedCpaLinksObject.svgLinkMiddlePointX = tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset;
                tempDisplayedCpaLinksObject.svgLinkMiddlePointY = displayedSvgHeight - this.initialLinkOffset - topOffset;
                tempDisplayedCpaLinksObject.svgLinkUpperMiddle = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset -1.5 },${displayedSvgHeight - this.initialLinkOffset - topOffset - 3} l ${ 3 } ${ 3 } l ${ -3 } ${ 3 }`;
                tempDisplayedCpaLinksObject.svgLinkLowerMiddle = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset +1.5 },${displayedSvgHeight - this.initialLinkOffset - topOffset - 3} l ${ -3 } ${ 3 } l ${ 3 } ${ 3 }`;
              }
              
              if (tempDisplayedCpaLinksObject.fromPoint.isDisplayed && tempDisplayedCpaLinksObject.toPoint.isDisplayed) {
                tempDisplayedCpaLinks.push(tempDisplayedCpaLinksObject);
              }

              // save offsetsUsed in displayedOffsetsUsed to change svgHeight if needed
              this.saveDisplayedTopOffsets();
            });
          }
        } else {
          // COLUMNS SORTED BY INDEXEX DURING SVG LINK TOP OFFSET DEFINITION
          displayedSvgCpaPoints.forEach((displayedCpaPoint, displayedCpaPointTableIndex) => {
            if (this.isCpaMerged) {
              const cpaArray = this.getMergedCpaArray(displayedCpaPointTableIndex);

              const filteredCpaArray = cpaArray.filter(cpa => {
                return (cpa.cpaLinkedColumn > displayedCpaPointTableIndex)
              }).sort((a, b) => {
                if (a.cpaLinkedColumn > b.cpaLinkedColumn) {
                  return 1;
                } else if (a.cpaLinkedColumn < b.cpaLinkedColumn) {
                  return -1;
                } else {
                  return 0;
                }
              });

              filteredCpaArray.forEach(cpa => {
                const tempDisplayedCpaLinksObject = { fromPoint: displayedSvgCpaPoints[cpa.cpaColumn], toPoint: displayedSvgCpaPoints[cpa.cpaLinkedColumn], diff: (cpa.cpaLinkedColumn - displayedCpaPointTableIndex), cpa: cpa};
                const topOffset = this.defineTopOffset(displayedCpaPointTableIndex, cpa.cpaLinkedColumn);
                const linkLineSize = tempDisplayedCpaLinksObject.toPoint.x - tempDisplayedCpaLinksObject.fromPoint.x - (2 * topOffset);
                const halfLinkLineSize = linkLineSize>0 ? linkLineSize/2 : -linkLineSize/2;
                tempDisplayedCpaLinksObject.svgLink = `M${tempDisplayedCpaLinksObject.fromPoint.x},${displayedSvgHeight - 20} a${topOffset} ${topOffset} 0 0 1 ${topOffset} -${topOffset} h ${ linkLineSize>0 ? linkLineSize : -linkLineSize } a${topOffset} ${topOffset} 0 0 1 ${topOffset} ${topOffset}`;
                if (this.displayCpaPoints) {
                  tempDisplayedCpaLinksObject.svgLinkStart = `M${tempDisplayedCpaLinksObject.fromPoint.x},${displayedSvgHeight - this.initialLinkOffset} a${topOffset} ${topOffset} 0 0 1 ${topOffset} -${topOffset} h ${ halfLinkLineSize - 4}`;
                  tempDisplayedCpaLinksObject.svgLinkEnd = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset + 4},${displayedSvgHeight - this.initialLinkOffset - topOffset} h ${ halfLinkLineSize - 4 } a${topOffset} ${topOffset} 0 0 1 ${topOffset} ${topOffset}`;
                  tempDisplayedCpaLinksObject.svgLinkMiddlePointX = tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset;
                  tempDisplayedCpaLinksObject.svgLinkMiddlePointY = displayedSvgHeight - this.initialLinkOffset - topOffset;
                  tempDisplayedCpaLinksObject.svgLinkUpperMiddle = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset -1.5 },${displayedSvgHeight - this.initialLinkOffset - topOffset - 3} l ${ 3 } ${ 3 } l ${ -3 } ${ 3 }`;
                  tempDisplayedCpaLinksObject.svgLinkLowerMiddle = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset +1.5 },${displayedSvgHeight - this.initialLinkOffset - topOffset - 3} l ${ -3 } ${ 3 } l ${ 3 } ${ 3 }`;
                } else {
                  tempDisplayedCpaLinksObject.svgLinkStart = `M${tempDisplayedCpaLinksObject.fromPoint.x},${displayedSvgHeight} v${-this.initialLinkOffset} a${topOffset} ${topOffset} 0 0 1 ${topOffset} -${topOffset} h ${ halfLinkLineSize - 4}`;
                  tempDisplayedCpaLinksObject.svgLinkEnd = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset + 4},${displayedSvgHeight - this.initialLinkOffset - topOffset} h ${ halfLinkLineSize - 4 } a${topOffset} ${topOffset} 0 0 1 ${topOffset} ${topOffset} v${this.initialLinkOffset}`;
                  tempDisplayedCpaLinksObject.svgLinkMiddlePointX = tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset;
                  tempDisplayedCpaLinksObject.svgLinkMiddlePointY = displayedSvgHeight - this.initialLinkOffset - topOffset;
                  tempDisplayedCpaLinksObject.svgLinkUpperMiddle = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset -1.5 },${displayedSvgHeight - this.initialLinkOffset - topOffset - 3} l ${ 3 } ${ 3 } l ${ -3 } ${ 3 }`;
                  tempDisplayedCpaLinksObject.svgLinkLowerMiddle = `M${tempDisplayedCpaLinksObject.fromPoint.x + halfLinkLineSize + topOffset +1.5 },${displayedSvgHeight - this.initialLinkOffset - topOffset - 3} l ${ -3 } ${ 3 } l ${ 3 } ${ 3 }`;
                }
                
                if (tempDisplayedCpaLinksObject.fromPoint.isDisplayed && tempDisplayedCpaLinksObject.toPoint.isDisplayed) {
                  tempDisplayedCpaLinks.push(tempDisplayedCpaLinksObject);
                }
              })

              // save offsetsUsed in displayedOffsetsUsed to change svgHeight if needed
              this.saveDisplayedTopOffsets();
            }
          })
        }
        return tempDisplayedCpaLinks;
      }
      return [];
    },
    cpaLinkHeight: function() {
      return this.cpaLinkHeightInPx + 'px';
    },
    cpaLinkWidth: function() {
      return this.cpaLinkWidthInPx + 'px';
    },
    svgHeight: function() {
      const returnedSvgHeight = this.displayedOffsetsUsed.reduce((previousValue, currentValue) => {
          const returnedMinHeight = currentValue.offsetValue + 28;
          return (previousValue > returnedMinHeight) ? previousValue : returnedMinHeight;
        }, 110);
      if (this.lastCalculatedSvgHeight !== returnedSvgHeight) {
        this.$emit('svg-height-updated', { svgHeight: returnedSvgHeight });
      }
      return returnedSvgHeight;
    }
  },
  methods: {
    onMouseOverCpaPoint: function(displayedCpaPoint) {
      if (this.displayCpaPoints) {
        this.svgHoverPoint = displayedCpaPoint;
      }
    },
    onMouseLeaveCpaPoint: function() {
      if (this.displayCpaPoints) {
        this.svgHoverPoint = undefined;
      }
    },
    onMouseOverHeader: function(columnIndex, columnLinkedIndex) {
      if (columnLinkedIndex === undefined) {
        this.$emit('mouse-over-header', { column: columnIndex });
      } else {
        this.$emit('mouse-over-header', { column: columnIndex, columnLinked: columnLinkedIndex });
      }
    },
    onMouseLeaveHeader: function() {
      this.$emit('mouse-leave-header', undefined);
    },
    isHoverLink: function(link) {
      if (this.svgHoverPoint === undefined) {
        const activateHoverLinkOnColumnHover = true;
        if (activateHoverLinkOnColumnHover) {
          if ((this.hoverCoordinates === undefined) || (this.hoverCoordinates.column === undefined)) {
            return false;
          } else if (this.hoverCoordinates.columnLinked === undefined) {
            return [link.fromPoint.columnIndex, link.toPoint.columnIndex ].includes(this.hoverCoordinates.column);
          } else {
            return [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(link.fromPoint.columnIndex)
                    && [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(link.toPoint.columnIndex);
          }
        } else {
          return false;
        }
      } else if ((link === undefined) || (link.fromPoint === undefined) || (link.toPoint === undefined)){
        return false;
      } else if ((this.svgHoverPoint.x === link.fromPoint.x) && (this.svgHoverPoint.y === link.fromPoint.y)) {
        return true;
      } else if ((this.svgHoverPoint.x === link.toPoint.x) && (this.svgHoverPoint.y === link.toPoint.y)) {
        return true;
      } else {
        return false;
      }
    },
    saveDisplayedTopOffsets: function() {
      // update this.displayedOffsetsUsed only when it is changed
      let arrayModified = (this.displayedOffsetsUsed.length !== this.offsetsUsed.length);
      this.offsetsUsed.forEach((point, pointIndex) => {
        if (this.displayedOffsetsUsed[pointIndex] === undefined) {
          arrayModified = true; 
        } else if ((this.displayedOffsetsUsed[pointIndex].offsetValue !== point.offsetValue)
                  || (this.displayedOffsetsUsed[pointIndex].startIndex !== point.startIndex)
                  || (this.displayedOffsetsUsed[pointIndex].endIndex !== point.endIndex)) {
          arrayModified = true;
        }
      });
      if (arrayModified) {
        this.displayedOffsetsUsed = this.offsetsUsed;
      }      
    },
    defineTopOffset: function(startIndex, endIndex) {
      let offsetTested = this.offsetGap;
      const offsetUsedForThisIndexes = this.offsetsUsed.filter(offsetUsed => {
        const offsetIsFinishedBefore = (offsetUsed.endIndex <= startIndex);
        const offsetIsStartedAfter = (offsetUsed.startIndex >= endIndex);
        return !(offsetIsFinishedBefore || offsetIsStartedAfter);
      }).map(offsetUsed => {
        return offsetUsed.offsetValue;
      });

      let offsetNotFound = true;
      while (offsetNotFound) {
        if (offsetUsedForThisIndexes.includes(offsetTested)) {
          offsetTested += this.offsetGap;
        } else {
          offsetNotFound = false;
          this.offsetsUsed.push({offsetValue: offsetTested, startIndex, endIndex});
        }
      }
      return offsetTested;
    },
    initTopOffset: function(defaultOffset) {
      this.offsetGap = defaultOffset;
      //this.reservedOffsets = 
      this.offsetsUsed = [];
    },
    getSortedFilteredAndMergedCpaArrayToDisplay: function() {
      if (this.isCpaMerged) {
        const returnedCpaArray = this.filteredCpaElementsToMerge.filter((filteredCpaElement) => {
          return ((typeof filteredCpaElement.cpaHead === "number") && (typeof filteredCpaElement.cpaTail === "number") && (filteredCpaElement.cpaHead < filteredCpaElement.cpaTail))
        }).map((filteredCpaElement) => {
          const returnedFilteredCpaElement = { ...filteredCpaElement };
          returnedFilteredCpaElement.cpaColumn = filteredCpaElement.cpaHead;
          returnedFilteredCpaElement.cpaLinkedColumn = filteredCpaElement.cpaTail;
          return returnedFilteredCpaElement;
        }).sort((a, b) => {
          const aDiffCpaIndexes = Math.abs(a.cpaLinkedColumn - a.cpaColumn);
          const bDiffCpaIndexes = Math.abs(b.cpaLinkedColumn - b.cpaColumn);
          // console.log(`[displayedCpaLinks] [sort] a = ${JSON.stringify(a)} and b = ${JSON.stringify(b)}`);
          // console.log(`[getSortedFilteredAndMergedCpaArrayToDisplay] [sort] aDiffCpaIndexes = ${JSON.stringify(aDiffCpaIndexes)} and bDiffCpaIndexes = ${JSON.stringify(bDiffCpaIndexes)}`);
          if (aDiffCpaIndexes > bDiffCpaIndexes) {
            return 1;
          } else if (aDiffCpaIndexes < bDiffCpaIndexes) {
            return -1;
          } else {
            if (a.cpaLinkedColumn > b.cpaLinkedColumn) {
              return 1;
            } else if (a.cpaLinkedColumn < b.cpaLinkedColumn) {
              return -1;
            } else {
              return 0;
            }
          }
        });
        return returnedCpaArray;
      } else {
        return [];
      }
    },
    getMergedCpaArray: function(columnIndexInRow) {
      if (this.isCpaMerged) {
        const returnedCpaArray = this.filteredCpaElementsToMerge.filter((filteredCpaElement) => {
          return ((filteredCpaElement.cpaHead === columnIndexInRow) || (filteredCpaElement.cpaTail === columnIndexInRow))
        }).map((filteredCpaElement) => {
          const returnedFilteredCpaElement = { ...filteredCpaElement };
          returnedFilteredCpaElement.cpaColumn = (filteredCpaElement.cpaHead === columnIndexInRow) ? filteredCpaElement.cpaHead : filteredCpaElement.cpaTail;
          returnedFilteredCpaElement.cpaLinkedColumn = (filteredCpaElement.cpaHead === columnIndexInRow) ? filteredCpaElement.cpaTail : filteredCpaElement.cpaHead;
          return returnedFilteredCpaElement;
        });
        return returnedCpaArray;
      } else {
        return [];
      }
    },
    /*
    getMergedCpaArray: function(columnIndexInRow) {
      if (this.isCpaMerged) {
        const returnedCpaArray = this.cpaTableMatrixToMerge.getRows().filter((cpaRow) => {
          return ((cpaRow[0] === columnIndexInRow) || (cpaRow[1] === columnIndexInRow))
        }).map((cpaFiltered) => {
          return {
            cpaIsDefined: cpaFiltered ? ((cpaFiltered[2] !== undefined) && (cpaFiltered[4] !== undefined) && (cpaFiltered[5] !== undefined) && (cpaFiltered[0] !== undefined) && (cpaFiltered[1] !== undefined)) : false,
            cpaLabel: cpaFiltered[3],
            cpaColumn: (cpaFiltered[0] === columnIndexInRow) ? cpaFiltered[0] : cpaFiltered[1],
            cpaLinkedColumn: (cpaFiltered[0] === columnIndexInRow) ? cpaFiltered[1] : cpaFiltered[0],
            cpaLink: cpaFiltered[2],
            cpaScore: cpaFiltered[4],
            cpaCoverage: cpaFiltered[5],
            cpaHead: cpaFiltered[0],
            cpaTail: cpaFiltered[1]
          };
        });
        return returnedCpaArray;
      } else {
        return [];
      }
    },
    */
    selectCpa: function(cpa) {
      console.log("[selectCpa] -~~-> select-cpa");
      this.$emit('select-cpa', cpa);
    },
  }
};
</script>
<style scoped>

.clickable {
  cursor: pointer
}

</style>